

import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaMicrophone, FaPaperPlane, FaUpload } from "react-icons/fa";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import Select from "react-select";
const ReportIssuModal = ({
  show,
  handleClose,
  buttons = ["डाइमेंशन इश्यू", "बर्र", "जंग लगा हुआ","डेंट / गड्ढा"],
}) => {
  const [form, setForm] = useState({
    issue: "",
    notes: "",
  });
  const issueOptions = [
    { value: "material", label: "Material Issue" },
    { value: "process", label: "Process Issue" },
    { value: "quality", label: "Quality Issue" },
  ];
  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }
    try {
      const payload = {
        issue: form.issue,
        notes: form.notes,
      };
      const response = await axios.post(
        `${config.API}/operator/reportissue`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const { success, message } = response.data;
      if (success === true) {
        toast.success(message || "Request submitted successfully!");
        setForm({ issue: "", notes: "" });
        handleClose();
      } else if (success === false) {
        toast.error(message || "Something went wrong!");
      }
    } catch (err) {
      if (err.response && err.response.status === 422) {
        const backendMessage = err.response.data?.message || "Validation error!";
        toast.error(backendMessage);
      } else {
        console.error("Error submitting material issue:", err.message);
        toast.error("Failed to submit material issue request!");
      }
    }
  };
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
       <Modal.Header closeButton>
  <h2 className="font_family">Report an Issue</h2>
  </Modal.Header>    
      <Modal.Body className="p-4">
        <div className="">
          <Select
            options={issueOptions}
            placeholder="-- Select Issue Type --"
            value={issueOptions.find((opt) => opt.value === form.issue) || null}
            onChange={(selected) =>
              setForm({ ...form, issue: selected ? selected.value : "" })
            }
            isClearable
          />
        </div>
        <div className="border rounded p-3 mb-3 mt-4">
          <div className="bg-secondary-subtle text-muted p-3 rounded mb-3 w-50">
            Describe the issue, upload image or voice input
          </div>
          <div className="row g-3 mb-4">
            {buttons.map((btn, idx) => (
              <div className="col-md-4 col-sm-4 col-6" key={idx}>
                <div
                  className="bg-white rounded p-3 text-center h-100 border customModalOperator"
                  style={{
                    cursor: "pointer",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                  }}
                  onClick={() => setForm({ ...form, notes: btn })}
                >
                  <strong>{btn}</strong>
                </div>
              </div>
            ))}
          </div>
          <div className="border rounded p-2">
            <div className="d-flex align-items-center">
              <div className="d-flex gap-2">
                <Button variant="light" className="border">
                  <FaUpload />
                </Button>
                <Button variant="light" className="border">
                  <FaMicrophone />
                </Button>
              </div>
              <div className="flex-grow-1 mx-2">
                <textarea
                  className="form-control border-0 shadow-none"
                  rows="1"
                  placeholder="Type here..."
                  style={{ resize: "none" }}
                  value={form.notes}
                  onChange={(e) => setForm({ ...form, notes: e.target.value })}
                />
              </div>
              <div>
                <Button variant="primary" onClick={handleSubmit}>
                  <FaPaperPlane />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ReportIssuModal;
